import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { BoardModule } from '../components/BoardModule';
import { BoardReadiness } from '../components/BoardReadiness';
import { EngagementModels } from '../components/EngagementModels';
import { Reveal } from '../components/Reveal';
import { profile } from '../data/profile';
export function BoardExperiencePage() {
  return <>
      <PageHeader label="Board Experience" title="Advising leadership beyond the operating role" description="Current advisory board service, focused on commercial viability, market trend analysis, and corporate growth strategy." data-id="element-446" data-mp="4ayuufvxsw7y" />
      <BoardModule showLabel={false} data-id="element-447" data-mp="eappchkhzb81" />
      <BoardReadiness data-id="element-448" data-mp="1kp74j9vlzb26" />
      <EngagementModels data-id="element-449" data-mp="1kq033nkeyu98" />

      <section className="w-full border-t border-line bg-white py-20 lg:py-24" data-id="element-450" data-mp="1kofba5phhpf2">
        <div className="mx-auto max-w-shell px-6 sm:px-8" data-id="element-451" data-mp="1pn8n7tp4h8d4">
          <Reveal data-id="element-452" data-mp="wccfwfxya7xb">
            <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-453" data-mp="wcuma5ebu2iy">
              <p className="max-w-2xl font-serif text-[24px] leading-[1.45] text-navy lg:text-[30px]" data-id="element-454" data-mp="sa7q5samhvfy">
                {profile.closing}
              </p>
              <Link to="/contact" className="group inline-flex shrink-0 items-center gap-2.5 bg-navy px-7 py-4 text-sm font-semibold text-white transition-colors duration-150 ease-premium hover:bg-navy-deep focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2" data-id="element-455" data-mp="n9tiibcxonig">
                Start a conversation
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-premium group-hover:translate-x-1" aria-hidden="true" data-id="element-456" data-mp="4leqplusl5gl" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>;
}